import type { TableUISettings } from "@lib/hooks/useTableUISettings";

export type { Ticket } from "../types/ticket.types";

/** Resolved UI settings consumed by the ticket column factories. */
export interface TicketColumnSettings {
  colWidth: { name: number; text: number; badge: number; actions: number };
  iconClass: string;
  cellText: string;
  badgeSize: "sm" | "md";
}

/** Resolve the optional TableUISettings into the column settings with defaults. */
export function resolveTicketColumnSettings(uiSettings?: TableUISettings): TicketColumnSettings {
  return {
    colWidth: uiSettings?.colWidth ?? { name: 200, text: 180, badge: 110, actions: 100 },
    iconClass: uiSettings?.iconClass ?? "w-3 h-3",
    cellText: uiSettings?.cellText ?? "text-sm",
    // StatusBadge only supports sm/md — map the uiSettings badge size onto it.
    badgeSize: uiSettings?.badgeSize === "md" ? "md" : "sm",
  };
}
